import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';

interface StepNavigationProps {
  onBack: () => void;
  onNext: () => void;
  nextButtonText?: string;
  nextButtonDisabled?: boolean;
}

export function StepNavigation({ onBack, onNext, nextButtonText, nextButtonDisabled }: StepNavigationProps) {
  return (
    <div className="flex items-center justify-end gap-2">
      <Button variant="default" onClick={onBack}>
        <Icon className="lucide--arrow-left" />
        Back
      </Button>

      <Button disabled={nextButtonDisabled} variant="primary" onClick={onNext} data-testid="matter-creator-next-button">
        {nextButtonText ? `Next: ${nextButtonText}` : 'Create Matter'}
        <Icon className="lucide--arrow-right" />
      </Button>
    </div>
  );
}
